module.exports = __webpack_public_path__ + "assets/images/menuIcons/menuBeacon2_ru.png";